import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Templates } from "../../../../../services/fakeDb";

export const DEPARTMENTS = [
  { value: "LAB", text: "Laboratory", color: "info" },
  { value: "RAD", text: "Radiology", color: "secondary" },
  { value: "CARDIO", text: "Cardiology", color: "danger" },
  { value: "CLINIC", text: "Clinical", color: "success" },
  { value: "REHAB", text: "Rehabilitation", color: "warning" },
];

export const getDepartment = (value) =>
  DEPARTMENTS.find((department) => department.value === value) || {
    value,
    text: value || "Unassigned",
    color: "light",
  };

// templates are numbered per department, a RAD 1 is Ultrasound and not Hematology
export const getTemplateName = (template, department) => {
  if (template === undefined || template === null || template === "") return "";
  const found = Templates.collections.find((t) => t.department === department);
  return found?.components?.[template] || "";
};

export const getTemplates = (department) =>
  Templates.collections.find((t) => t.department === department)?.components ||
  [];

// "none", "n/a" and empty mean there is nothing to show
export const clean = (value) => {
  const text = String(value ?? "").trim();
  return !text || /^(none|n\/a|na|-|null|undefined)\.?$/i.test(text) ? "" : text;
};

export const PREFERENCES = {
  gender: "Male / Female",
  development: "Age group",
  equal: "Same for everyone",
};
export const getPreference = (value) =>
  PREFERENCES[String(value || "").toLowerCase()] ||
  (/^equal/i.test(String(value || "")) ? PREFERENCES.equal : "");

/**
 * Menus of the branch grouped per service id, cheapest first.
 * A service can only be sold thru a menu, so no menu means not offered.
 */
export const useServiceMenus = () => {
  const { collections = [] } = useSelector(({ menus }) => menus);
  return useMemo(() => {
    const byService = new Map();
    collections.forEach((menu) => {
      (menu?.packages || []).forEach((id) => {
        const key = Number(id);
        if (!byService.has(key)) byService.set(key, []);
        byService.get(key).push(menu);
      });
    });
    byService.forEach((menus) =>
      menus.sort((a, b) => (Number(a.opd) || 0) - (Number(b.opd) || 0)),
    );
    return byService;
  }, [collections]);
};

// the lowest price a patient pays for this service alone or in a package
export const lowestPrice = (menus = []) =>
  menus.reduce(
    (min, { opd }) => (Number(opd) > 0 && Number(opd) < min ? Number(opd) : min),
    Infinity,
  );
